module.exports = __webpack_public_path__ + "5ed64cecb1b1fbd4ebe88016550f0207.svg";